import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=2ec69d86&scoped=true&"
import script from "./clock.vue?vue&type=script&lang=js&"
export * from "./clock.vue?vue&type=script&lang=js&"
import style0 from "./clock.vue?vue&type=style&index=0&id=2ec69d86&lang=scss&scoped=true&"
import style1 from "./clock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec69d86",
  null
  
)

export default component.exports